"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _generateGUID = _interopRequireDefault(require("../generateGUID"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getUserToken = () => {
  const userToken = localStorage.getItem("push-notifications-user-token") || (0, _generateGUID.default)();
  localStorage.setItem("push-notifications-user-token", userToken);
  return userToken;
};
var _default = exports.default = getUserToken;